module.exports = __webpack_public_path__ + "img/16l009-09.a389eff1.png";